import {createBrowserRouter, Navigate} from "react-router-dom";
import ErrorBoundaryRoute from "../reusableComponents/components/generics/ErrorBoundaryRoute";
import SignIn from "../pages/SignIn";
import SuccessMessage from "../pages/SuccessMessage";
import FailureMessage from "../pages/FailureMessage";
import ProtectedRoute from "./protectedRoute";
import ForgotPassword from "../pages/forgotPassword";
import ResetPassword from "../pages/resetPassword";
import ResetSuccessMessage from "../pages/resetPasswordSuccess";
import ResetFailure from "../pages/resetFailure";
import InsureeContent from "../components/InsureeContent";
import PolicyHolder from "../pages/PolicyHolder";
import SuccessPolicyholder from "../pages/SuccessPolicyholder";
import ContractContent from "../components/Contract/ContractContent";
import PaymentContent from "../components/payement/PaymentContent";
import PaymentFormContent from "../components/payement/PaymentFormContent";
import UpdatePassword from "../pages/UpdatePassword";
import {
  PORTAL,
  POLICY_HOLDER,
  POLICY_HOLDER_SUCCESS,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILED,
  FORGOT_PASSWORD,
  SET_PASSWORD,
  RESET_SUCCESS,
  RESET_FAILURE,
  PORTAL_INSUREE,
  PORTAL_CONTRACT,
  HOME_PAGE,
  POLICYHOLDER_DETAILS,
  FOSA_VERIFICATION,
  HEALTH_FACILITY,
  PAYMENT_PORTAL,
  PAYMENT_PORTAL_FORM,
  CLAIM_PORTAL,
  CLAIM_FORM,
  STAFF_MANAGEMENT,
  CLAIM_FORM_BY_ID,
  Pre_Autharization,
  Pre_Autharization_Form, INVOICE_URL, INVOICE_CREATE_URL,
  ADMIN_USERS,
  ADMIN_USER_FORM,
  ADMIN_USER_FORM_BY_ID,
  MEDICAL_ITEMS,
  MEDICAL_SERVICES,
  VERIFY_USER_AND_UPDATE_PASSWORD,
} from "./constant";
import ContractDetailsContent from "../components/Contract/ContractDetailsContent";
import HomePage from "../pages/homePage/HomePage";
import PolicyholderDetailsPage from "../pages/policyholderDetails/PolicyholderDetailsPage";
import Verification from "../pages/verificationPage/Verification";
import ClaimContent from "../pages/ClaimPage.js/Claim";
import ClaimFormPage from "../pages/ClaimPage.js/ClaimFormPage";
import HealthFacility from "../pages/HealthFacility/HealthFacility";
import StaffManagementPage from "../pages/staffManagementPage/StaffManagementPage";
import VerifyInsuree from "../components/verificationscreen/VerifyInsuree";
import {PreAutharisation} from "../pages/preAuth/PreAutharisation";
import PreAuthDetails from "../components/preAuth/PreAuthDetails";
import InvoicePage from "../pages/Invoice/InvoicePage";
import CreateInvoicePage from "../pages/Invoice/CreateInvoicePage";
import InvoiceDetailPage from "../pages/Invoice/InvoiceDetailPage";
import AdminPage from "../pages/admin/Admin";
import AdminFormPage from "../pages/admin/AdminFormPage";
import MedicalItemsContent from "../pages/medicalItmesPage/MedicalItemsPage";
import MedicalServicesContent from "../pages/medicalServicesPage/MedicalServicesPage";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

export const route = createBrowserRouter([
  {
    path: PORTAL,
    element: isAuthenticated() ? <Navigate to={HOME_PAGE}/> : <SignIn/>,
  },
  // {
  //   path: SIGN_UP,
  //   element: <SignUp />,
  // },
  {
    path: ADMIN_USERS,
    // element: <PolicyHolder />,
    element: <ProtectedRoute element={<AdminPage />} />
  },
  {
    path: ADMIN_USER_FORM,
    // element: <PolicyHolder />,
    element: <ProtectedRoute element={<AdminFormPage />} />
  },
  {
    path: `${ADMIN_USER_FORM_BY_ID}/:id`,
    element: <ProtectedRoute element={<AdminFormPage />} />,
  },
  {
    path: POLICY_HOLDER,
    // element: <PolicyHolder />,
    element: <ProtectedRoute element={<PolicyHolder/>}/>
  },
  {
    path: `${POLICY_HOLDER_SUCCESS}/:id`,
    // element: <SuccessPolicyholder />,
    element: <ProtectedRoute element={<SuccessPolicyholder/>}/>
  },
  {
    path: SIGN_UP_SUCCESS,
    element: <SuccessMessage/>,
  },
  {
    path: SIGN_UP_FAILED,
    element: <FailureMessage/>,
  },
  {
    path: FORGOT_PASSWORD,
    element: <ForgotPassword/>,
  },
  {
    path: SET_PASSWORD,
    element: <ResetPassword/>,
  },
  {
    path: RESET_SUCCESS,
    element: <ResetSuccessMessage/>,
  },
  {
    path: RESET_FAILURE,
    element: <ResetFailure/>,
  },
  {
    path: VERIFY_USER_AND_UPDATE_PASSWORD,
    element: <UpdatePassword/>,
  },
  {
    path: HOME_PAGE,
    element: <ProtectedRoute element={<HomePage/>}/>,
  },
  {
    path: POLICYHOLDER_DETAILS,
    element: <ProtectedRoute element={<PolicyholderDetailsPage/>}/>,
  },
  {
    path: PORTAL_INSUREE,
    element: <ProtectedRoute element={<InsureeContent/>}/>,
  },
  {
    path: PORTAL_CONTRACT,
    element: <ProtectedRoute element={<ContractContent/>}/>,
  },
  {
    path: `${PORTAL_CONTRACT}/:id`,
    element: <ProtectedRoute element={<ContractDetailsContent/>}/>,
  },
  {
    path: PAYMENT_PORTAL,
    element: <ProtectedRoute element={<PaymentContent/>}/>,
  },
  {
    path: `${PAYMENT_PORTAL_FORM}/:id`,
    element: <ProtectedRoute element={<PaymentFormContent/>}/>,
  },
  // {
  //   path: "/portal/payment",
  //   element: <ProtectedRoute element={<PaymentContent />} />,
  // },

  {
    path: FOSA_VERIFICATION,
    element: <ProtectedRoute element={<Verification/>}/>,
  },
  {
    path: `${FOSA_VERIFICATION}/:id`,
    element: <ProtectedRoute element={<VerifyInsuree/>}/>,
  },
  {
    path: HEALTH_FACILITY,
    element: <ProtectedRoute element={<HealthFacility/>}/>,
  },
  {
    path: CLAIM_PORTAL,
    element: <ProtectedRoute element={<ClaimContent/>}/>,
  },
  {
    path: CLAIM_FORM,
    element: <ProtectedRoute element={<ClaimFormPage/>}/>,
  },
  {
    path: `${CLAIM_FORM_BY_ID}/:id`,
    element: <ProtectedRoute element={<ClaimFormPage/>}/>,
  },
  {
    path: `${MEDICAL_ITEMS}`,
    element: <ProtectedRoute element={<MedicalItemsContent/>}/>,
  },
  {
    path: `${MEDICAL_SERVICES}`,
    element: <ProtectedRoute element={<MedicalServicesContent/>}/>,
  },
  {
    path: STAFF_MANAGEMENT,
    element: <ProtectedRoute element={<StaffManagementPage/>}/>,
  },
  {
    path: `${STAFF_MANAGEMENT}/:id`,
    element: <ProtectedRoute element={<VerifyInsuree/>}/>,
  },
  {
    path: Pre_Autharization,
    element: <ProtectedRoute element={< PreAutharisation/>}/>,
  },
  {
    path: Pre_Autharization_Form,
    element: <ProtectedRoute element={< PreAuthDetails/>}/>,
  },
  {
    path: `${Pre_Autharization_Form}/:id`,
    element: <ProtectedRoute element={< PreAuthDetails/>}/>,
  },
  {
    path: INVOICE_URL,
    element: <ProtectedRoute element={<InvoicePage/>}/>
  },
  {
    path: `${INVOICE_URL}/:id`,
    element: <ProtectedRoute element={<InvoiceDetailPage/>}/>
  },
  {
    path: INVOICE_CREATE_URL,
    element: <ProtectedRoute element={<CreateInvoicePage/>}/>
  },
  {
    path: "*",
    element: <SignIn/>,
  },

  {
    errorElement: <ErrorBoundaryRoute/>,
  },
]);
